import { ReactNode } from 'react';

export interface DropdownMenuItem {
  label: string;
  icon: ReactNode;
  onClick: (e: React.MouseEvent) => void;
  variant?: 'default' | 'danger';
}

interface DropdownMenuProps {
  isOpen: boolean;
  onClose: () => void;
  items: DropdownMenuItem[];
}

/**
 * DropdownMenu - Menu dropdown reutilizável
 *
 * Uso:
 * ```tsx
 * <DropdownMenu
 *   isOpen={showMenu}
 *   onClose={() => setShowMenu(false)}
 *   items={[
 *     { label: 'Editar', icon: <Edit />, onClick: handleEdit },
 *     { label: 'Excluir', icon: <Trash2 />, onClick: handleDelete, variant: 'danger' }
 *   ]}
 * />
 * ```
 */
export const DropdownMenu = ({ isOpen, onClose, items }: DropdownMenuProps) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop to close menu */}
      <div
        className="fixed inset-0 z-10"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      />

      {/* Menu */}
      <div className="absolute right-0 top-full mt-1 z-20 bg-[#2a2a2a] border border-[#333333] rounded-lg shadow-lg min-w-[140px] overflow-hidden">
        {items.map((item, index) => (
          <button
            key={index}
            onClick={item.onClick}
            className={`
              w-full flex items-center gap-2 px-4 py-2.5 text-sm
              hover:bg-[#333333] transition-colors
              ${item.variant === 'danger' ? 'text-red-400' : 'text-[#CCCCCC]'}
            `}
          >
            <span className="w-4 h-4">{item.icon}</span>
            <span>{item.label}</span>
          </button>
        ))}
      </div>
    </>
  );
};

export default DropdownMenu;
